import { attempt } from "@omni/utils/function.utils";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { Spinner } from "@/components/General/Spinner/spinner.component";
import { TooltipType } from "@/components/General/Tooltip/tooltip.types";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as OrderDetailsModule from "@/redux/modules/api/data/orderDetail/orderDetail.module";
import * as OrderDetailsSelectors from "@/redux/modules/api/data/orderDetail/orderDetail.selectors";
import { EcornerService } from "@/services/eCorner.service";
import { Config } from "@/utils/config.utils";
import { logoutCleanUp } from "@/utils/customer";

import { OrderOverviewComponent } from "./orderOverview.component";

type Props = {
    innerHTML: any;
    redirectUrl: any;
    additionalServiceTooltip?: string;
};

const OrderOverview = ({
    innerHTML,
    redirectUrl,
    additionalServiceTooltip
}: Props) => {
    const dispatch = useThunkDispatch();
    const orderDetails = useSelector(OrderDetailsSelectors.getOrder);
    const isOrderDetailsLoading = useSelector(OrderDetailsSelectors.isLoading);

    const storeDetails = orderDetails?.store;

    const tooltip: TooltipType | undefined = additionalServiceTooltip
        ? attempt(() => JSON.parse(additionalServiceTooltip), undefined)
        : undefined;

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        dispatch(OrderDetailsModule.load()).then(async (action) => {
            if (
                action.type ===
                    OrderDetailsModule.OrderDetailsConstants.FAILURE &&
                redirectUrl &&
                !Config.general.author
            ) {
                window.location.href = redirectUrl;
            }

            // Clean-up customer details when on an ecorner desktop
            if (await EcornerService.isEcornerEnvironment()) {
                logoutCleanUp();
            }
        });
    }, []);

    return isOrderDetailsLoading ? (
        <Spinner />
    ) : (
        <OrderOverviewComponent
            innerHTML={innerHTML}
            orderDetails={orderDetails}
            storeDetails={storeDetails}
            additionalServiceTooltip={tooltip}
        />
    );
};

export { OrderOverview };
